import { createContext, useContext, useState } from "react";
import axios from "axios";

const PaymentContext = createContext();

export const PaymentProvider = ({ children }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [buttonText, setButtonText] = useState("Book Now");

  const createInvoiceAndPay = async () => {
    setIsProcessing(true);
    setButtonText("Processing...");

    try {
      const response = await axios.post(
        "http://localhost:3001/api/v1/payments/sawatour-invoice",
        // "https://sawaapi.space/api/v1/payments/sawatour-invoice",
        {
          transactionId: `TST-${Math.random().toString(5).substring(2, 7)}`, // Unique transaction ID
          paymentAccountIdentifier: "SAWA-RWF",
          paymentItems: [
            {
              unitAmount: 15000,
              quantity: 1,
              code: "PC-454847b2c9",
            },
          ],
          description: "SAWA Studio Visit",
          expiryAt: "2025-09-30T01:00:00+02:00",
          language: "EN",
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-API-Version": "2",
          },
        }
      );

      // ✅ Redirect to the checkout page
      const paymentUrl = response.data.response?.data?.paymentLinkUrl;
      console.log(paymentUrl);
      if (paymentUrl) {
        window.location.href = paymentUrl;
      } else {
        console.error("Invoice created but no checkout URL:", response.data);
      }
    } catch (error) {
      console.error("Error creating invoice:", error.response?.data || error);
    } finally {
      setButtonText("Book Now");
    }
  };

  return (
    <PaymentContext.Provider
      value={{ createInvoiceAndPay, isProcessing, buttonText }}
    >
      {children}
    </PaymentContext.Provider>
  );
};

export const usePayment = () => useContext(PaymentContext);

// import { createContext, useContext, useState } from "react";
// import axios from "axios";

// const PaymentContext = createContext();

// export const PaymentProvider = ({ children }) => {
//   const [isProcessing, setIsProcessing] = useState(false);
//   const [buttonText, setButtonText] = useState("Book Now");
  

//   const createInvoiceAndPay = async () => {
//     setIsProcessing(true);
//     setButtonText("Processing...");

//     try {
//       const response = await axios.post(
//         "https://sawaapi.space/api/v1/payments/sawatour-invoice",
//         {
//           transactionId: `TST-${Math.random().toString(5).substring(2, 7)}`, // Unique transaction ID
//           paymentAccountIdentifier: "SAWA-RWF",
//           paymentItems: [
//             {
//               unitAmount: 15000,
//               quantity: 1,
//               code: "PC-454847b2c9",
//             },
//           ],
//           description: "SAWA Studio Visit",
//           expiryAt: "2025-09-30T01:00:00+02:00",
//           language: "EN",
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             "irembopay-secretKey": "sk_live_8f055ff007784cb2a53dac4aa8d616fc",
//             "X-API-Version": "2",
//           },
//         }
//       );
//       console.log(
//         "Irembo Secret Key:",
//         process.env.REACT_APP_IREMBO_SECRET_KEY
//       );

//       const paymentUrl = response.data.paymentUrl;
//       if (paymentUrl) {
//         window.location.href = paymentUrl; // Redirect user to complete payment
//       } else {
//         console.error("Invoice created but no checkout URL:", response.data);
//         setIsProcessing(false);
//       }
//     } catch (error) {
//       console.error("Error creating invoice:", error.response?.data || error);
//       setIsProcessing(false);
//     } finally {
//       setButtonText("Book Now");
//     }
//   };

//   return (
//     <PaymentContext.Provider
//       value={{ createInvoiceAndPay, isProcessing, buttonText }}
//     >
//       {children}
//     </PaymentContext.Provider>
//   );
// };

// export const usePayment = () => useContext(PaymentContext);
